module.exports = __webpack_public_path__ + "media/wordmark.d0c6d2c3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/wordmark.svg
// module id = 492
// module chunks = 0